export class GoogleWorkspaceGroup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groupId",
            "baseName": "groupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceGroup.attributeTypeMap;
    }
    constructor() {
    }
}
